module.exports = {
  test: {
    baseURL: "http://localhost:3005",
  },
  development: {
    baseURL: "http://localhost:3005",
  },
  stage: {
    baseURL: "https://dbrdbk6r7h46l.cloudfront.net",
  },
  production: {
    baseURL: "https://d3od5si8vgcekb.cloudfront.net",
  },
}[process.env.NODE_ENV || "production"];
